import type { Teardown } from "./registry";

export type WipeOriginOptions = {
	elements: Iterable<HTMLElement>;
	/** Written on each element as a percentage. */
	property: string;
};

export const createWipeOrigin = ({ elements, property }: WipeOriginOptions): Teardown => {
	const listeners = new AbortController();
	const tracked = [...elements];
	const options = { signal: listeners.signal };

	for (const element of tracked) {
		/* One pair per element because these two do not propagate: the bubbling pair re-aims
		   the wipe from the side of a link every time the pointer crosses one. */
		const aim = (event: MouseEvent) => {
			const box = element.getBoundingClientRect();

			element.style.setProperty(
				property,
				event.clientX < box.left + box.width / 2 ? "0%" : "100%",
			);
		};

		element.addEventListener("mouseenter", aim, options);
		element.addEventListener("mouseleave", aim, options);
	}

	return () => {
		listeners.abort();

		for (const element of tracked) element.style.removeProperty(property);
	};
};
